// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  min-height: calc(100vh - 77px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 26px;
  background-color: #f5f1e9;
}

.auth-card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.08);
  border: 1px solid #e8e4df;
  padding: 2rem 1.75rem;
}

.auth-title {
  margin: 0 0 0.25rem 0;
  font-family: 'Neucha', cursive;
  font-size: 1.75rem;
  font-weight: 400;
  color: #4e3f3a;
  text-align: center;
}

.auth-subtitle {
  margin: 0 0 1.5rem 0;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #6b5d58;
  text-align: center;
}

.auth-2fa-hint {
  font-size: 0.8125rem;
  color: #6b5d58;
  margin: 0 0 1rem 0;
}

.auth-2fa-hint strong {
  color: #4e3f3a;
}

.auth-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.auth-info {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #166534;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.auth-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.auth-field label {
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  color: #4e3f3a;
}

.auth-field input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  padding: 0.625rem 0.875rem;
  border: 1px solid #e8e4df;
  border-radius: 10px;
  background: #faf9f7;
  color: #4e3f3a;
}

.auth-field input:focus {
  outline: none;
  border-color: #fc761f;
  box-shadow: 0 0 0 3px rgba(252, 118, 31, 0.2);
  background: #fff;
}

.auth-field--invalid label {
  color: #991b1b;
}

.auth-field--invalid input {
  border-color: #f87171;
  background: #fffbeb;
}

.auth-field-msg {
  font-size: 0.75rem;
  color: #991b1b;
  line-height: 1.3;
}

.auth-hint {
  font-size: 0.75rem;
  color: #6b5d58;
}

.auth-submit {
  margin-top: 0.5rem;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  font-weight: 600;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 10px;
  background: #fc761f;
  color: #fff;
  cursor: pointer;
}

.auth-submit:hover:not(:disabled) {
  background: #e56a18;
}

.auth-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.auth-muted {
  font-size: 0.875rem;
  color: #6b5d58;
  margin: 1rem 0 0 0;
  text-align: center;
}

.auth-footer {
  margin: 1.5rem 0 0 0;
  padding-top: 1rem;
  border-top: 1px solid #e8e4df;
  font-size: 0.875rem;
  color: #6b5d58;
  text-align: center;
}

.auth-footer a {
  color: #fc761f;
  text-decoration: none;
  font-weight: 500;
}

.auth-footer a:hover {
  text-decoration: underline;
}

.auth-footer-sep {
  margin: 0 0.5rem;
  color: #c4bcb5;
}

.auth-link-button {
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: inherit;
  font-weight: 500;
  color: #fc761f;
  cursor: pointer;
}

.auth-link-button:hover:not(:disabled) {
  text-decoration: underline;
}

.auth-link-button:disabled {
  color: #a8a09b;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".auth-page {\n  min-height: calc(100vh - 77px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 26px;\n  background-color: #f5f1e9;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 420px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.08);\n  border: 1px solid #e8e4df;\n  padding: 2rem 1.75rem;\n}\n\n.auth-title {\n  margin: 0 0 0.25rem 0;\n  font-family: 'Neucha', cursive;\n  font-size: 1.75rem;\n  font-weight: 400;\n  color: #4e3f3a;\n  text-align: center;\n}\n\n.auth-subtitle {\n  margin: 0 0 1.5rem 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  color: #6b5d58;\n  text-align: center;\n}\n\n.auth-2fa-hint {\n  font-size: 0.8125rem;\n  color: #6b5d58;\n  margin: 0 0 1rem 0;\n}\n\n.auth-2fa-hint strong {\n  color: #4e3f3a;\n}\n\n.auth-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.auth-info {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  color: #166534;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.auth-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.auth-field label {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #4e3f3a;\n}\n\n.auth-field input {\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  padding: 0.625rem 0.875rem;\n  border: 1px solid #e8e4df;\n  border-radius: 10px;\n  background: #faf9f7;\n  color: #4e3f3a;\n}\n\n.auth-field input:focus {\n  outline: none;\n  border-color: #fc761f;\n  box-shadow: 0 0 0 3px rgba(252, 118, 31, 0.2);\n  background: #fff;\n}\n\n.auth-field--invalid label {\n  color: #991b1b;\n}\n\n.auth-field--invalid input {\n  border-color: #f87171;\n  background: #fffbeb;\n}\n\n.auth-field-msg {\n  font-size: 0.75rem;\n  color: #991b1b;\n  line-height: 1.3;\n}\n\n.auth-hint {\n  font-size: 0.75rem;\n  color: #6b5d58;\n}\n\n.auth-submit {\n  margin-top: 0.5rem;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: 10px;\n  background: #fc761f;\n  color: #fff;\n  cursor: pointer;\n}\n\n.auth-submit:hover:not(:disabled) {\n  background: #e56a18;\n}\n\n.auth-submit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.auth-muted {\n  font-size: 0.875rem;\n  color: #6b5d58;\n  margin: 1rem 0 0 0;\n  text-align: center;\n}\n\n.auth-footer {\n  margin: 1.5rem 0 0 0;\n  padding-top: 1rem;\n  border-top: 1px solid #e8e4df;\n  font-size: 0.875rem;\n  color: #6b5d58;\n  text-align: center;\n}\n\n.auth-footer a {\n  color: #fc761f;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.auth-footer a:hover {\n  text-decoration: underline;\n}\n\n.auth-footer-sep {\n  margin: 0 0.5rem;\n  color: #c4bcb5;\n}\n\n.auth-link-button {\n  padding: 0;\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: 500;\n  color: #fc761f;\n  cursor: pointer;\n}\n\n.auth-link-button:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.auth-link-button:disabled {\n  color: #a8a09b;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
